// SearchCreator.js
import { connect } from 'react-redux';

import fetchFeeds from '../action/fetchFeeds.js';
import fetchUserSearch from '../action/fetchUserSearch.js';
import getOperationData from '../selector/getOperationData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';
import getListData from '../selector/getListData.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import SearchCreator from '../component/SearchCreator.jsx';
import withSearchQuery from '../component/WithSearchQuery.jsx';

import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import {
  CONFIG_PRIORITY_CONFIGURE,
  CONFIG_PRIORITY_PRESENCE_USER,
  CONFIG_PRIORITY_PRESENCE_CLIENT,
} from '../resource/configPriority.js';

const mapStateToProps = (state, { category, query }) => {
  const { sorts: sortings } = getSelectedQueryOptionObject(
    state,
    '',
    getSelectedFeedQueryOptions(state, 'SEARCH_MESSAGE', undefined)
  );
  const sortingString = sortings.join('&');

  const hasQuery = !!query;
  const swaggerOnlineFeed = getOperationData(
    state,
    ['swaggerOnlineFeed'],
    'search'
  );
  const defaultSwaggerCategory = category || swaggerOnlineFeed;
  const swaggerSelectPath = ['search', 'user', query];
  const defaultSwaggerSelectPath = ['home', 'users', defaultSwaggerCategory];
  const isAuthed = !!getMeData(state, 'id');

  const searchSwaggerIds = getListData(state, swaggerSelectPath, 'itemIds');
  const defaultSwaggerIds = getListData(
    state,
    defaultSwaggerSelectPath,
    'itemIds'
  );

  const isSearchSwaggerFetched = getNetworkingData(
    state,
    [...swaggerSelectPath, 'firstPage'],
    'isFetched'
  );
  const isDefaultSwaggerFetched = getNetworkingData(
    state,
    [...defaultSwaggerSelectPath, 1],
    'isFetched'
  );

  const isRemoteConfigMerged = isAuthed
    ? getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_USER)
    : getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_CLIENT) ||
      getIsRemoteConfigMerged(state, CONFIG_PRIORITY_CONFIGURE);

  return {
    sortingString,
    query,
    defaultSwaggerCategory,
    isAuthed,
    isSwaggerFetched: hasQuery
      ? isSearchSwaggerFetched
      : isDefaultSwaggerFetched,
    hasQuery,
    swaggerIds: hasQuery ? searchSwaggerIds : defaultSwaggerIds,
    isRemoteConfigMerged,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
    fetchUserSearch: data =>
      dispatch(
        fetchUserSearch({
          ...data,
          selectPath: ['search', 'user', data.query],
        })
      ),
  };
};

export default withSearchQuery(
  connect(mapStateToProps, mapDispatchToProps)(SearchCreator)
);
